import { render, staticRenderFns } from "./ModalComponentProject.vue?vue&type=template&id=c106204e&scoped=true"
import script from "./ModalComponentProject.vue?vue&type=script&lang=js"
export * from "./ModalComponentProject.vue?vue&type=script&lang=js"
import style0 from "./ModalComponentProject.vue?vue&type=style&index=0&id=c106204e&prod&scoped=true&lang=scss"
import style1 from "./ModalComponentProject.vue?vue&type=style&index=1&id=c106204e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c106204e",
  null
  
)

export default component.exports